import { config } from "common/config";

export const AUTH_CONFIG = {
    domain: config.VITE_AUTH0_DOMAIN!,
    clientId: config.VITE_AUTH0_CLIENT_ID!,
    callbackUrl: config.VITE_AUTH0_CALLBACK_URL!,
};
